<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>Among Katuns, Shepherds and Geological Miracles</h1>
    <div class='tourPic'>
      <img src='@/assets/daytours/tour5/01.jpg' />
    </div>

    <div>
      <ul class='fa-ul'>
        <li>
          <!-- <span class='fa-li'><i class='fas fa-tree fa-2x'></i></span>  -->
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDescription'
            ><h4 class='titles'>Tour description</h4></a
          >
          <div class='collapse' id='tourDescription'>
            <p class='pasus'>
              This tour takes us from 50 to 1.900 meters above sea level in only
              a few hours. It begins from the largest urban center and ends up
              in a remote, high and magnificent Durmitor massif. Durmitor is
              known for its geological peculiarities and natural beauty owing to
              which it is proclaimed national park and along with Tara canyon
              listed as UNESCO world heritage site.
            </p>
            <p class='pasus'>
              The mountain is well-known for periodical shepherds’ settlements
              called katuns where in the summer cattle breeders come with cows
              and sheep and stay until first cold days and snow. Mysterious
              medieval tombstones – stećci, jointly nominated by Montenegro and
              the neighboring countries Bosnia, Serbia and Croatia and recently
              listed as UNESCO world heritage site, are situated in the mountain
              too.
            </p>
            <p class='pasus'>
              On our way to Durmitor we won’t miss the opportunity to visit the
              lookouts offering stunning views on Piva River canyon and Piva
              Lake, the largest reservoir of drinking water in the Balkans as
              well as on the most famous of 18 glacial lakes in Durmitor – Black
              Lake. If you wish so, we can pay a visit to one of the most
              interesting Orthodox monasteries in Montenegro – Piva Monastery.
            </p>
            <p class='pasus'>
              A lunch at mountain restaurant and food made of local products are
              highly recommended.
            </p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDetails'
            ><h4 class='titles'>Tour details</h4></a
          >
          <div class='collapse' id='tourDetails'>
            <p class='pasus'>Type of tour: Private</p>
            <p class='pasus'>Availability: June – October</p>
            <p class='pasus'>Group size – 1-7</p>
            <p class='pasus'>Departure from: Podgorica</p>
            <p class='pasus'>Difficulty level: easy</p>
            <p class='pasus'>Duration: 12 h</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <h4 class='titles'>Highlights</h4>
          <vue-picture-swipe :items='items'></vue-picture-swipe>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#itinerary'
            ><h4 class='titles'>Itinerary</h4></a
          >
          <div class='collapse' id='itinerary'>
            <ul class='square'>
              <li class='pasus'>
                8.30 a.m. - a pick up at your place of stay or at the place we
                agree upon.
              </li>
              <li class='pasus'>
                During a comfortable one hour and forty minutes long drive we
                enjoy the landscapes, altering with the altitude change, until
                we reach our first stop – a lookout over Piva Lake (once Canyon
                of Komarnica River).
              </li>
              <li class='pasus'>
                While drinking coffee the next 30-40 minutes we enjoy the view
                on the canyon, surrounding pastures and Piva Mountain on the
                other side of the canyon.
              </li>
              <li class='pasus'>
                At 10:30 we continue the tour descending closer to the lake, the
                largest reservoir of drinking water in the Balkans, crossing the
                long bridge over lake. Having passed by a small town of Pluzine,
                we diverge from the main road and start our ascent to Piva
                plateau and Durmitor Mountain.
              </li>
              <li class='pasus'>
                Just after noon we arrive at the small mountain restaurant
                where, if preferred so, we can take lunch, have a snack or
                simply have a coffee.
              </li>
              <li class='pasus'>
                The next few hours we enjoy the unreal surroundings of Durmitor
                Mountain, to reach the most famous glacial lake in Montenegro –
                Black Lake, around 4 p.m.
              </li>
              <li class='pasus'>
                A return to Podgorica is planned for 6 p.m. where we arrive
                around 8 p.m.
              </li>
            </ul>
             <div class='tour-time'>
              <p> <i class='fas fa-clock'></i> 5 hours</p>
              <p> <i class='fas fa-route'></i> 290 km</p>
            </div>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#prices'
            ><h4 class='titles'>Prices:</h4></a
          >
          <div class='collapse' id='prices'>
            <ul class='square'>
              <li class='pasus'>1 person – 220 EUR</li>
              <li class='pasus'>2 persons – 120 EUR p/person</li>
              <li class='pasus'>3 persons – 85 EUR p/person</li>
              <li class='pasus'>4 persons – 75 EUR p/person</li>
              <li class='pasus'>5 persons - 90 EUR p/person</li>
              <li class='pasus'>6 persons – 80 EUR p/person</li>
              <li class='pasus'>7 persons – 70 EUR p/person</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#included'
            ><h4 class='titles'>Included in price:</h4></a
          >
          <div class='collapse' id='included'>
            <ul class='square'>
              <li class='pasus'>Driving by car/van</li>
              <li class='pasus'>Bottle of water</li>
              <li class='pasus'>National park tickets</li>
              <li class='pasus'>Professional guiding service- English</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#info'
            ><h4 class='titles'>Practical info:</h4></a
          >
          <div class='collapse' id='info'>
            <ul class='square'>
              <li class='pasus'>
                We recommend that you carry with you a jacket, a cap,
                sunglasses, some sweets and footwear adequate to conditions in
                the mountain area.
              </li>
              <li class='pasus'>
                The difference in altitude is 1.850 meters. We start at the
                elevation of 50 meters to reach the highest point at 1.907
                meters.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#optional'
            ><h4 class='titles'>Optional:</h4></a
          >
          <div class='collapse' id='optional'>
            <ul class='square'>
              <li class='pasus'>Visit to Piva Monastery</li>
              <li class='pasus'>Additional walks during the tour</li>
              <li class='pasus'>
                Itinerary changes as agreed (do not affect the price)
              </li>
              <li class='pasus'>Lunch at mountain restaurant</li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/daytours/tour5/01.jpg'),
          thumbnail: require('@/assets/daytours/tour5/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour5/02.jpg'),
          thumbnail: require('@/assets/daytours/tour5/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour5/03.jpg'),
          thumbnail: require('@/assets/daytours/tour5/03.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour5/04.jpg'),
          thumbnail: require('@/assets/daytours/tour5/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour5/05.jpg'),
          thumbnail: require('@/assets/daytours/tour5/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour5/06.jpg'),
          thumbnail: require('@/assets/daytours/tour5/06.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour5/07.jpg'),
          thumbnail: require('@/assets/daytours/tour5/07.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour5/08.jpg'),
          thumbnail: require('@/assets/daytours/tour5/08.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour5/09.jpg'),
          thumbnail: require('@/assets/daytours/tour5/09.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/DT5_AmongKatuns.vue